import { NavItemKey } from "../../state";
import { NAV_ITEMS } from "../../constants/navigation";
import useSchoolStatus from "../../hooks/manager/useSchoolStatus";

const useNavLabel = () => {
  const { isCramSchool } = useSchoolStatus();

  const getNavLabel = (key: NavItemKey) => {
    const labels = NAV_ITEMS[key].labels;

    if (isCramSchool) {
      return labels.cram_school ?? labels.school;
    }

    return labels.school;
  };

  return { getNavLabel };
};

export default useNavLabel;
